import { modal$ } from '../stores/store-main.js';
export function scrollIntoView(element, offsetSelector = 'element-header', behavior) {
    const offsetElementRect = document
        .querySelector(offsetSelector)
        .getBoundingClientRect();
    document.querySelector('#main').scrollTo({
        top: element.getBoundingClientRect().top - offsetElementRect.height,
        left: 0,
        behavior,
    });
}
export function scrollToTop() {
    document.querySelector('#main').scrollTo(0, 0);
}
export function scrollToTopSmooth() {
    document
        .querySelector('#main')
        .scrollTo({ top: 0, left: 0, behavior: 'smooth' });
}
export function scrollingElement(event) {
    const element = event.target;
    return element.scrollTop > 0;
}
export function hideModalOnOutsideClick() {
    const ignoreElements = [
        '[data-cy="filter-btn"]',
        '[data-cy="goToOldMap-btn"]',
        '[data-cy="logout-btn"]',
        '.popup',
    ];
    const backdrop = document.querySelector('.modal-backdrop');
    const header = document.querySelector('element-header');
    const handler = (event) => {
        const ignore = !!ignoreElements.filter((query) => document.querySelector(query)?.contains(event.target)).length;
        if (ignore)
            return;
        backdrop.removeEventListener('click', handler);
        header.removeEventListener('click', handler);
        modal$.next(undefined);
    };
    backdrop.addEventListener('click', handler);
    header.addEventListener('click', handler);
}
export function hideOnOutsideClick(getElementsCallback, hideCallback) {
    const body = document.querySelector('body');
    const handler = (event) => {
        const ignore = !!getElementsCallback().filter((e) => e?.contains(event.target)).length;
        if (ignore)
            return;
        body.removeEventListener('click', handler);
        hideCallback();
    };
    body.addEventListener('click', handler);
}
export function getBrowserCode() {
    let sBrowser = 'unknown';
    const sUsrAg = navigator.userAgent;
    if (sUsrAg.indexOf('Firefox') > -1) {
        sBrowser = 'firefox';
    }
    else if (sUsrAg.indexOf('Opera') > -1) {
        sBrowser = 'opera';
    }
    else if (sUsrAg.indexOf('Trident') > -1) {
        sBrowser = 'ie';
    }
    else if (sUsrAg.indexOf('Edge') > -1) {
        sBrowser = 'edge';
    }
    else if (sUsrAg.indexOf('Chrome') > -1) {
        sBrowser = 'chrome';
    }
    else if (sUsrAg.indexOf('Safari') > -1) {
        sBrowser = 'safari';
    }
    return sBrowser;
}
export function waitForElement(selector, parent) {
    return new Promise((resolve) => {
        if (parent.querySelector(selector)) {
            const el = parent.querySelector(selector);
            return resolve({ element: el, bbox: el.getBoundingClientRect() });
        }
        const observer = new MutationObserver(() => {
            if (parent.querySelector(selector)) {
                const el = parent.querySelector(selector);
                resolve({ element: el, bbox: el.getBoundingClientRect() });
                observer.disconnect();
            }
        });
        observer.observe(parent, { childList: true, subtree: true });
    });
}
export function getStyleNumberValue(element, property) {
    const style = getComputedStyle(element);
    if (Array.isArray(property)) {
        return property.map((p) => {
            const value = style.getPropertyValue(p);
            return Number(value.replace('px', ''));
        });
    }
    else {
        const value = style.getPropertyValue(property);
        return Number(value.replace('px', ''));
    }
}
//# sourceMappingURL=dom.js.map